import React from "react"
import { Dropdown } from "semantic-ui-react"
import { Link } from "react-router-dom"
const HouseholdMenu = ({ description }) => (
  <Dropdown
    text={description || "New Household"}
    className="App_Household_Menu"
  >
    <Dropdown.Menu>
      <Dropdown.Item value="-1" as={Link} to="/browse-households">
        Switch Households
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
)

export default HouseholdMenu
